"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Availability = void 0;
var _sort = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/sort"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _useMediaQuery = _interopRequireDefault(require("@mui/material/useMediaQuery"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _availabilityTiles = require("@kyruus/availability-tiles");
var _uiTheme = _interopRequireDefault(require("@kyruus/ui-theme"));
var _providerComponents = require("@kyruus/provider-components");
var _globals = require("../../lib/constants/globals");
var _styles = require("./styles");
var _constants = require("./constants");
const Availability = exports.Availability = (0, _reactIntl.injectIntl)(_ref => {
  let {
    config,
    provider,
    onTimeSlotsClick,
    onViewMoreClick,
    shouldRenderSlotsAsButtons,
    slots,
    apptInfo,
    bookOnlineUrl,
    intl,
    bookingOptionsButton,
    slotsAriaProps,
    slotsStatus,
    onAvailabilityTilesLoaded,
    track
  } = _ref;
  const showCount = (0, _get2.default)(config, 'provider_tile.show_availability_counts', true);
  // slots are sorted by location and then date by default
  // this component will group slots by date then VisibleAvailabilityTiles will
  // trim the list given max slots to display, so we want to sort by date first
  const formattedSlots = (0, _availabilityTiles.formatAvailabilityForGroupTiles)(slots, showCount);
  const availabilities = (0, _sort.default)(formattedSlots).call(formattedSlots, (a, b) => a.unformattedDate.localeCompare(b.unformattedDate));
  const providerName = (0, _providerComponents.getProviderDisplayName)(provider);
  const isScreenLargeOrAbove = (0, _useMediaQuery.default)(`(min-width:${_uiTheme.default.screen_large})`);
  const isScreenBetweenSmallAndMedium = (0, _useMediaQuery.default)(`(min-width:${_uiTheme.default.screen_small}) and (max-width:${_uiTheme.default.screen_medium})`);
  const maxAvailabilitiesToDisplay = isScreenLargeOrAbove || isScreenBetweenSmallAndMedium ? _constants.MAX_AVAILABILITIES_TO_DISPLAY_DESKTOP : _constants.MAX_AVAILABILITIES_TO_DISPLAY_MOBILE;
  const handleBookingOptionsClick = (providerId, e) => {
    track(_globals.LOGGING.MESSAGE.REQUEST_APPOINTMENT, {
      button_location: 'search_results',
      cta: 'secondary'
    });
    bookingOptionsButton.onClick(providerId, e);
  };
  return /*#__PURE__*/_react.default.createElement(_styles.AvailabilityTiles, null, slotsStatus === _globals.SLOTS_LOADING_STATUS && /*#__PURE__*/_react.default.createElement(_availabilityTiles.LoadingAvailabilityTiles, {
    maxAvailabilitiesToDisplay: maxAvailabilitiesToDisplay,
    compactTiles: true,
    tileSize: "small",
    compactHeight: showCount ? undefined : 30
  }), slotsStatus === _globals.SLOTS_SUCCESS_STATUS && /*#__PURE__*/_react.default.createElement(_availabilityTiles.VisibleAvailabilityTiles, {
    availabilities: availabilities,
    onAvailabilityTilesLoaded: onAvailabilityTilesLoaded,
    viewMoreBookOnlineUrl: (0, _providerComponents.appendApptInfoToBookingUrl)(apptInfo, bookOnlineUrl),
    maxAvailabilitiesToDisplay: maxAvailabilitiesToDisplay,
    displayLinkToViewMoreAvailabilities: true,
    display: true,
    bookOnlineUrl: bookOnlineUrl,
    compactTiles: true,
    tileSize: "small",
    dataTestId: "provider-tile-availability-tiles",
    shouldRenderSlotsAsButtons: shouldRenderSlotsAsButtons,
    onTimeSlotsClick: onTimeSlotsClick,
    providerId: provider.id,
    onViewMoreClick: onViewMoreClick,
    viewMoreAriaLabel: intl.formatMessage(_providerComponents.messages.availabilityViewMoreAriaLabel, {
      providerName
    }),
    moreAvailabilitiesLinkText: intl.formatMessage(_providerComponents.messages.moreAvailabilitiesLinkText),
    slotsAriaExpanded: slotsAriaProps.expanded,
    slotsAriaControls: slotsAriaProps.controls,
    slotsAriaHasPopup: slotsAriaProps.hasPopup,
    slotsAriaLabel: (date, _time, _locationName, count) => intl.formatMessage(_providerComponents.messages.availabilityGroupedSlotsAriaLabel, {
      count,
      date,
      providerName
    }),
    availabilityCountMessage: count => intl.formatMessage(_providerComponents.messages.availabilityCountMessage, {
      count
    }),
    bookingOptionsButton: {
      text: intl.formatMessage(_providerComponents.messages.bookingOptionsButton),
      ariaLabel: intl.formatMessage(_providerComponents.messages.bookingOptionsButtonAriaLabel, {
        providerName
      }),
      onClick: handleBookingOptionsClick,
      ariaControls: bookingOptionsButton.ariaControls,
      ariaHasPopup: bookingOptionsButton.ariaHasPopup,
      ariaExpanded: bookingOptionsButton.ariaExpanded
    }
  }));
});